import {
  SET_STATISTICS_DATA,
  SET_MAIN_SEARCH_PARAMS,
  SET_IS_COUNTING,
  RESET_REQUESTS_DATA,
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_FILTERED_REQUESTS,
  SET_DASHBOARD_ITEMS,
} from './actionTypes';

export const setStatisticsData = (data) => {
  return {
    type: SET_STATISTICS_DATA,
    payload: data,
  };
};

export const setMainSearchParams = (searchParams) => {
  return {
    type: SET_MAIN_SEARCH_PARAMS,
    payload: searchParams,
  };
};

export const setIsCounting = (booleanVal) => {
  return {
    type: SET_IS_COUNTING,
    payload: booleanVal,
  };
};

export const resetRequestsData = () => {
  return {
    type: RESET_REQUESTS_DATA,
  };
};

export const setDashboardData = (data) => {
  return {
    type: SET_DASHBOARD_DATA,
    payload: data,
  };
};

export const setDashboardFilteredRequests = (filteredDashboardRequests) => ({
  type: SET_DASHBOARD_FILTERED_REQUESTS,
  payload: filteredDashboardRequests,
});

export const setDashboardItems = (dashboardItems) => {
  return {
    type: SET_DASHBOARD_ITEMS,
    payload: dashboardItems,
  };
};
